import { render, staticRenderFns } from "./Vendor.vue?vue&type=template&id=21b2696d&"
import script from "./Vendor.vue?vue&type=script&lang=js&"
export * from "./Vendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports